import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmacao-modal',
  templateUrl: './confirmacao-modal.component.html',
  styleUrls: ['./confirmacao-modal.component.scss']
})
export class ConfirmacaoModalComponent implements OnInit {

  // Título da janela modal
  title: string;
  // Mensagem para confirmação
  text: string;
  // Alguma mensagem extra, se necessária
  extraText: string[];
  // A mensagem extra deve ser "null" senão houver algum

  buttonYesText: string;
  buttonNoText: string;

  constructor(
    private dialogRef: MatDialogRef<ConfirmacaoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.title = data.title;
    this.text = data.message;
    this.extraText = data.extraMessage;
    this.buttonYesText = data.buttonYesText ?? 'Sim';
    this.buttonNoText = data.buttonNoText ?? 'Não';
  }

  ngOnInit() {
  }

  /**
   * Método chamado na resposta "Sim" do modal.
   *
   * @returns Retorna o boolean "true", indicando que o valor escolhido foi "Sim"
   */
  acceptChange() {
    this.dialogRef.close(true);
  }
}
